var React = require('react');

function CloseLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M47.707.293a1 1 0 010 1.414l-46 46a1 1 0 01-1.414-1.414l46-46a1 1 0 011.414 0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.293.293a1 1 0 011.414 0l46 46a1 1 0 01-1.414 1.414l-46-46a1 1 0 010-1.414z","key":1})]);
}

CloseLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CloseLight;

CloseLight.default = CloseLight;
